import { REST_BODY_TYPE, REST_PARAM_TYPE } from '../enums.js';
const createRestHeaderParamMapper = (type) => ({ from, to, }) => ({
    type,
    from,
    to,
});
const createRestBodyParamMapper = (type) => ({ to } = {}) => ({
    type,
    from: '',
    to,
});
export const json = createRestBodyParamMapper(REST_BODY_TYPE.JSON);
export const form = createRestBodyParamMapper(REST_BODY_TYPE.FORM);
export const cookie = createRestHeaderParamMapper(REST_PARAM_TYPE.COOKIE);
export const header = createRestHeaderParamMapper(REST_PARAM_TYPE.HEADER);
export const path = createRestHeaderParamMapper(REST_PARAM_TYPE.PATH);
export const query = createRestHeaderParamMapper(REST_PARAM_TYPE.QUERY);
//# sourceMappingURL=restParamMapper.js.map